import { render, staticRenderFns } from "./Zakat.vue?vue&type=template&id=126b24b2&scoped=true"
import script from "./Zakat.vue?vue&type=script&lang=js"
export * from "./Zakat.vue?vue&type=script&lang=js"
import style0 from "./Zakat.vue?vue&type=style&index=0&id=126b24b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126b24b2",
  null
  
)

export default component.exports